/** Shared MUI DataGrid skin — headers, cells, rows, footer, scrollbar. */
import { IPD_COLORS } from "./ipdColors";

export const tableContainerSx = {
  '& .MuiDataGrid-root': {
    border: 'none',
    color: IPD_COLORS.textPrimary,
    backgroundColor: IPD_COLORS.cardBg,
    fontSize: 13,
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: IPD_COLORS.panelHeaderBg,
    color: IPD_COLORS.textSecondary,
    borderBottom: `1px solid ${IPD_COLORS.border}`,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    minHeight: '44px !important',
    maxHeight: '44px !important',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 600,
  },
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid ${IPD_COLORS.border}`,
    color: IPD_COLORS.textPrimary,
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiDataGrid-row': {
    '&:hover': { backgroundColor: 'rgba(26, 43, 75, 0.03)' },
    '&.Mui-selected': { backgroundColor: `${IPD_COLORS.selectedBg} !important` },
  },
  '& .MuiDataGrid-footerContainer': {
    backgroundColor: IPD_COLORS.panelHeaderBg,
    borderTop: `1px solid ${IPD_COLORS.border}`,
    color: IPD_COLORS.textSecondary,
    minHeight: 48,
  },
  '& .MuiTablePagination-root': { color: IPD_COLORS.textSecondary },
  // MUI renders the label + displayed-rows as <p> tags whose default margins push
  // them off the baseline of the select/arrows — zero the margins to align the row.
  '& .MuiTablePagination-toolbar': { alignItems: 'center' },
  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    margin: 0,
    lineHeight: 1.5,
  },
  '& .MuiCheckbox-root': { color: IPD_COLORS.primary },
  '& .MuiDataGrid-columnSeparator': { display: 'none' },
  '& .MuiDataGrid-virtualScroller': {
    scrollbarWidth: 'thin',
    scrollbarColor: `${IPD_COLORS.scrollbarThumb} transparent`,
    '&::-webkit-scrollbar': { width: 6, height: 6 },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: IPD_COLORS.scrollbarThumb, borderRadius: 8 },
    '&::-webkit-scrollbar-thumb:hover': { backgroundColor: IPD_COLORS.scrollbarThumbHover },
  },
};
